var React = require('react');

function Keins (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Sonne_2","key":0}),React.createElement("g",{"id":"Sonne_2_1_","key":1}),React.createElement("g",{"id":"Wolke_x5F_03_x5F_hell","key":2}),React.createElement("g",{"id":"Wolke_x5F_01_x5F_dunkel_2","key":3})]);
}

Keins.displayName = "Keins";

Keins.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = Keins;

Keins.default = Keins;
